import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Non-deleted Retained Net Incomes with their cutoffs (newest first)
export const getRetainedNetIncomes = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL}/retained_net_income/getRetainedNetIncomes`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
